import { render, staticRenderFns } from "./testProgress.vue?vue&type=template&id=283e16c4&scoped=true&"
import script from "./testProgress.vue?vue&type=script&lang=js&"
export * from "./testProgress.vue?vue&type=script&lang=js&"
import style0 from "./testProgress.vue?vue&type=style&index=0&id=283e16c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e16c4",
  null
  
)

export default component.exports